import { createSelector } from 'reselect';

export const selectReferral = (state) => state.referral;
export const selectReferralName = (state) => selectReferral(state).name;

export const selectReferralReferees = (state) => state.referees;
export const selectReferralRefereesData = (state) => selectReferralReferees(state).data;
export const selectReferralRefereesTotal = (state) => selectReferralReferees(state).total;

export const selectPlayerReferralReferees = (state) => state.playerReferralReferees;
export const selectPlayerReferralRefereesData = (state) => selectPlayerReferralReferees(state).data;
export const selectPlayerReferralRefereesTotal = (state) => selectPlayerReferralReferees(state).total;

export const selectPlayerReferrals = (state) => state.playerReferrals;
export const selectPlayerReferralsData = (state) => selectPlayerReferrals(state).data;
export const selectPlayerReferralsTotal = (state) => selectPlayerReferrals(state).total;

export const selectPlayerReferralPeriods = (state) => state.playerReferralPeriods;
export const selectPlayerReferralPeriod = (state, id) => createSelector(
  () => selectPlayerReferralPeriods(state),
  (data) => data[id] || [],
)();

export const selectReferralAccumulatedPeriods = (state) => state.referralAccumulatedPeriods;
export const selectReferralTransferredPeriods = (state) => state.referralTransferredPeriods;
export const selectReferralFailedPeriods = (state) => state.referralFailedPeriods;
